import React from "react";

const LoadingSpinner = () => {
  return (
    <section className='loader_wrapper'>
      <div class="center">
        <h1>BIGSPECTRAINSIGHT</h1>
      </div>
    </section>
  );
};

export default LoadingSpinner;